import React from 'react';
import { getRandomIntInclusive } from '@helpers/helpers';
import { SocialManagerView } from '@specs/views';
import { ArtistCardBig } from '@components/Cards/ArtistCard/ArtistCardBig';
import s from './artistsGrid.module.scss';
interface PageBannerProps {
  data: SocialManagerView.publicProfile[];
}
const PageBannerComponent: React.FC<PageBannerProps> = ({
  data
}) => {
  const res = {
    ...data[getRandomIntInclusive(0, data.length - 1)]
  };
  return <div className={s.artistsGrid__banner} data-sentry-component="PageBannerComponent" data-sentry-source-file="ArtistPageBanner.tsx">
            <ArtistCardBig data={res} data-sentry-element="ArtistCardBig" data-sentry-source-file="ArtistPageBanner.tsx" />
        </div>;
};
export const PageBanner = React.memo(PageBannerComponent);